<template>
  <div class="relative">
    <input
      type="text"
      @input="onChange"
      v-model="form.search"
      @keydown.down="onArrowDown"
      @keydown.up="onArrowUp"
      @keydown.enter="onEnter"
      class="
        focus:ring-markencode-blue
        focus:border-markencode-blue
        block
        w-full
        shadow-sm
        text-xs 2xl:text-sm
        border-gray-300
        rounded-md
      "
    />
    <ul
      id="autocomplete-results"
      v-show="isOpen"
      v-if="! loading"
      class="
        py-0
        mt-1
        border border-gray-200
        h-auto
        shadow-sm
        rounded-md
        bg-white
        fixed
        z-10
      "
    >
      <li        
        v-for="(result, i) in results"
        :key="i"
        @click="setResult(result)"
        :class="{ 'is-active': i === wordIndex }"
        class="
          list-none
          text-left text-xs 2xl:text-sm
          py-1
          px-3
          cursor-pointer
          hover:bg-gray-400
          hover:text-white
        "
      >
        {{ result.word }}
      </li>
    </ul>
  </div>
</template>

<script>
import { pickBy, debounce } from 'lodash';

export default {
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    isAsync: {
      type: Boolean,
      required: false,
      default: false,
    },
    showSelection: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxResults: {
      type: Number,
      required: false,
      default: 8,
    },
  },
  data() {
    return {
      isOpen: false,
      results: [],
      form: {
        search: '',
      },
      loading: false,
      wordIndex: -1,
    };
  },
  watch: {
    form: {
      handler: debounce(function () {

        window.axios
          .get(
            this.route('markencode.brand-typology.search', {
              search: this.form.search,
            })
          )
          .then((response) => {
            this.results = response.data;
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
        
      }, 200),
      deep: true,
    },

    items: function (value, oldValue) {
      if (value.length !== oldValue.length) {
        this.results = value;
        this.loading = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    setResult(result) {
      this.$emit('selected', result);

      this.form.search = '';
      if (this.showSelection) {
        this.form.search = result;
      }

      this.isOpen = false;
    },

    filterResults() {
      if (this.isAsync) {
        this.loading = true;
      } else {
        this.results = this.items.filter((item) => {
          return item.word.toLowerCase().indexOf(this.form.search.toLowerCase()) > -1;
        }).slice(0, this.maxResults);
      }
    },
    
    onChange() {
      this.$emit('input', this.form.search);

      this.filterResults();
      this.isOpen = true;
    },

    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
        this.wordIndex = -1;
      }
    },
    
    onArrowDown() {
      if (this.wordIndex < this.results.length) {
        this.wordIndex = this.wordIndex + 1;
      }
    },

    onArrowUp() {
      if (this.wordIndex > 0) {
        this.wordIndex = this.wordIndex - 1;
      }
    },
    
    onEnter() {
      this.$emit('selected', this.results[this.wordIndex]);

      this.form.search = '';
      if (this.showSelection) {
        this.form.search = this.results[this.wordIndex];
      }

      this.isOpen = false;
      this.wordIndex = -1;
    },
  },
};
</script>

<style>
.is-active {
  background-color: #9ca3af;
  color: white;
}
</style>